import React from 'react';

const TrueFalseQuestion = ({
  question,
  answers,
  onAnswerChange,
  questionIndex
}) => {
  const handleOptionSelect = (optionId) => {
    onAnswerChange(question.id, optionId);
  };

  const isOptionSelected = (optionId) => {
    return answers[question.id] === optionId;
  };

  const handleScenarioSelect = (scenarioIndex, value) => {
    const currentAnswers = answers[question.id] || {};
    const newAnswers = {
      ...currentAnswers,
      [scenarioIndex]: value
    };
    onAnswerChange(question.id, newAnswers);
  };

  const isScenarioSelected = (scenarioIndex, value) => {
    const currentAnswers = answers[question.id] || {};
    return currentAnswers[scenarioIndex] === value;
  };

  // Check if this is a simple TRUE/FALSE question or complex scenario question
  const isSimpleQuestion = question.options && question.options.length > 0 && !question.scenarios;
  const isComplexQuestion = question.scenarios && question.scenarios.length > 0;

  return (
    <div className="bg-gray-100 border border-gray-200 rounded-lg p-6">
      {/* Contextual Information */}
      {question.context && (
        <div className="mb-6">
          <p className="text-gray-700 text-base leading-relaxed">
            {question.context}
          </p>
        </div>
      )}

      {/* Question Text */}
      <div className="mb-6">
        <p className="text-gray-900 text-base font-bold leading-relaxed">
          {question.text || question.question}
        </p>
      </div>

      {/* Simple TRUE/FALSE Question */}
      {isSimpleQuestion && (
        <div className="space-y-3">
          {question.options.map((option, optionIndex) => (
            <label
              key={option.id}
              className="flex items-center gap-3 p-3 cursor-pointer hover:bg-gray-50 rounded transition-colors duration-150 bg-white border border-gray-200"
            >
              <input
                type="radio"
                name={`question-${question.id}`}
                checked={isOptionSelected(option.id)}
                onChange={() => handleOptionSelect(option.id)}
                className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2"
              />
              <div className="flex-1">
                <span className="text-gray-800 text-base font-medium">
                  {option.text}
                </span>
              </div>
            </label>
          ))}
        </div>
      )}

      {/* Complex Scenario Question */}
      {isComplexQuestion && (
        <div className="bg-white border border-gray-200 rounded-lg overflow-hidden">
          {/* Header Row - Only Yes/No */}
          <div className="flex items-center justify-end bg-gray-50 border-b border-gray-200">
            <div className="flex gap-8 p-4">
              <span className="text-gray-700 font-medium min-w-[40px] text-center">Yes</span>
              <span className="text-gray-700 font-medium min-w-[40px] text-center">No</span>
            </div>
          </div>

          {/* Scenario Rows */}
          <div className="divide-y divide-dotted divide-gray-300">
            {question.scenarios.map((scenario, scenarioIndex) => (
              <div key={scenarioIndex} className="p-4">
                {/* Scenario Description */}
                <div className="mb-3">
                  <span className="text-gray-800 text-base">
                    {scenario}
                  </span>
                </div>
                
                {/* Yes/No Radio Buttons Below Scenario */}
                <div className="flex gap-8">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name={`scenario-${question.id}-${scenarioIndex}`}
                      checked={isScenarioSelected(scenarioIndex, 'yes')}
                      onChange={() => handleScenarioSelect(scenarioIndex, 'yes')}
                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2"
                    />
                    <span className="text-gray-700 text-sm font-medium">Yes</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="radio"
                      name={`scenario-${question.id}-${scenarioIndex}`}
                      checked={isScenarioSelected(scenarioIndex, 'no')}
                      onChange={() => handleScenarioSelect(scenarioIndex, 'no')}
                      className="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500 focus:ring-2"
                    />
                    <span className="text-gray-700 text-sm font-medium">No</span>
                  </label>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Selection Status */}
      <div className="mt-4 p-3 bg-white rounded border border-gray-200">
        <div className="text-sm text-gray-600">
          <div className="flex items-center gap-2">
            <span>
              {isSimpleQuestion ? 'Selected:' : 'Answered scenarios:'}
            </span>
            <span className="font-medium">
              {isSimpleQuestion ? 
                (answers[question.id] 
                  ? question.options.find(opt => opt.id === answers[question.id])?.text || 'Unknown'
                  : 'None selected'
                )
                : question.scenarios ? 
                  `${Object.keys(answers[question.id] || {}).length}/${question.scenarios.length}`
                  : '0/0'
              }
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrueFalseQuestion;

